import { render } from "./FeedbackMessage.vue?vue&type=template&id=4ac3afd5&scoped=true"
import script from "./FeedbackMessage.vue?vue&type=script&lang=js"
export * from "./FeedbackMessage.vue?vue&type=script&lang=js"

import "./FeedbackMessage.vue?vue&type=style&index=0&id=4ac3afd5&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac3afd5"]])

export default __exports__